import { InitOptions } from 'i18next'

import da from './translations/da.json' with { type: 'json' }
import en from './translations/en.json' with { type: 'json' }
import fi from './translations/fi.json' with { type: 'json' }
import nb from './translations/nb.json' with { type: 'json' }
import sv from './translations/sv.json' with { type: 'json' }

export const getI18nextInitParams = (allowDebug: boolean): InitOptions => ({
    debug: allowDebug && !!process.env.APP_DEBUG,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
        da,
        en,
        fi,
        nb,
        sv,
    },
})
